// 
export const CLAUSE_LIST = 'CLAUSE_LIST';
export const CLAUSE_PAGINATION = 'CLAUSE_PAGINATION';
export const CLAUSES_CATEGORY_TYPE_LIST = 'CLAUSES_CATEGORY_TYPE_LIST';
export const CLAUSE_TYPE_LIST = 'CLAUSE_TYPE_LIST';
 